import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { useVehicles } from '@/modules/shared/context/vehicles/VehiclesContext'
import { ViewModeUi } from '@/modules/drivers/shared/viewBars/ViewModeUi'

const ViewMode = ({
  blockedView = false,
  padding = false,
  vehicles = false
}: {
  blockedView?: boolean
  padding?: boolean
  vehicles?: boolean
}) => {
  const { activeViewMode, vehiclesIds } = useVehicles()
  const { pathname } = useLocation()

  const toggleUrl = React.useMemo(() => {
    if (blockedView) return ''
    const basePath = pathname.replace(/\/vehicle\/[^/]+.*$/, '')
    if (activeViewMode === 'group') {
      if (vehiclesIds.length === 0) return ''
      return `${basePath}/vehicle/${vehiclesIds[0]}`
    }
    return basePath
  }, [activeViewMode, pathname, vehiclesIds, blockedView])

  return (
    <ViewModeUi
      vehicles={vehicles}
      mode={activeViewMode as 'single' | 'group'}
      toggleUrl={toggleUrl}
      padding={padding}
    />
  )
}

export default ViewMode
